package com.timacookies.components.layouts

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.timacookies.components.sections.Footer
import com.timacookies.components.sections.NavHeader
import com.timacookies.components.widgets.FloatingBackToTop
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.ColumnScope
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gridRow
import com.varabyte.kobweb.compose.ui.modifiers.gridTemplateRows
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.data.getValue
import com.varabyte.kobweb.core.layout.Layout
import kotlinx.browser.document
import org.jetbrains.compose.web.css.fr
import org.jetbrains.compose.web.css.vh

class PageLayoutData(
  val title: String,
)

@Composable
@Layout
fun PageLayout(
  ctx: PageContext,
  content: @Composable ColumnScope.() -> Unit,
) {
  val data = ctx.data.getValue<PageLayoutData>()
  LaunchedEffect(data.title) {
    document.title = "TIMA COOKIES - ${data.title}"
  }

  Box(
    Modifier
      .fillMaxWidth()
      .minHeight(100.vh)
      .gridTemplateRows {
        size(1.fr)
        size(minContent)
      },
    contentAlignment = Alignment.Center,
  ) {
    Column(
      Modifier.fillMaxSize().gridRow(1),
      horizontalAlignment = Alignment.CenterHorizontally,
    ) {
      NavHeader()
      content()
    }
    Footer(Modifier.fillMaxWidth().gridRow(2))
    FloatingBackToTop()
  }
}
